import { z } from "zod";
import { variantSchema } from "./table";
/** The matches a card lists, newest first (review 0017 decision 97). */
export const CARD_RECENT = 10;
/**
 * `GET /api/players/:id/card` (review 0017): what anyone signed in sees of a player, the player
 * included (S16). Every finished match counts, bots too (decision 100); no match ids, tables or
 * times (S14, decision 97). Name and picture come from where the card opens, never from here.
 */
export const playerCardSchema = z.object({
    matches: z.number().int().nonnegative(),
    wins: z.number().int().nonnegative(),
    /** Whole percent won; null below ten matches, where a rate misleads (U4). */
    rate: z.number().int().min(0).max(100).nullable(),
    /** The game played most; null before the first match. */
    favourite: variantSchema.nullable(),
    recent: z
        .array(z.object({ variant: variantSchema, score: z.number().int(), won: z.boolean() }))
        .max(CARD_RECENT),
});
//# sourceMappingURL=playerCard.js.map